document.addEventListener("DOMContentLoaded", function () {
    const categoryLinks = document.querySelectorAll(".sidebar > ul > li > a");
    const sidebar = document.querySelector(".sidebar");
    const hamburger = document.querySelector(".hamburger");

    // Toggle sidebar on hamburger click
    if (hamburger) {
        hamburger.addEventListener("click", function () {
            sidebar.classList.toggle("open");
        });
    }

    categoryLinks.forEach((link) => {
        link.addEventListener("click", function (event) {
            let subMenu = this.nextElementSibling;

            if (subMenu && subMenu.tagName === "UL") {
                event.preventDefault();

                // Close all other submenus before opening a new one
                document.querySelectorAll(".sidebar ul ul").forEach((menu) => {
                    if (menu !== subMenu) {
                        menu.classList.remove("active");
                        menu.style.maxHeight = null;
                        menu.previousElementSibling.classList.remove("active-category"); // Remove active class from category
                    }
                });

                // Toggle the clicked submenu
                subMenu.classList.toggle("active");
                this.classList.toggle("active-category");

                // Smoothly expand/collapse the submenu
                subMenu.style.maxHeight = subMenu.classList.contains("active") 
                    ? subMenu.scrollHeight + "px" 
                    : null;
            }
        });
    });

    // Highlight the active category based on the current URL
    const currentPath = window.location.pathname;
    document.querySelectorAll(".sidebar ul li a").forEach(link => {
        if (link.getAttribute("href") === currentPath) {
            link.classList.add("active-category");

            // Ensure parent category is expanded if it's a subcategory
            let parentSubMenu = link.closest("ul");
            if (parentSubMenu && parentSubMenu.tagName === "UL") {
                parentSubMenu.classList.add("active");
                parentSubMenu.style.maxHeight = parentSubMenu.scrollHeight + "px";
                parentSubMenu.previousElementSibling.classList.add("active-category"); // Highlight parent category
            }
        }
    });
});

/*document.addEventListener("DOMContentLoaded", function () {
    const sidebar = document.querySelector(".sidebar");
    const footer = document.querySelector("footer");
    const navbar = document.querySelector(".navbar"); // Ensure this class matches your navbar
    const sidebarInitialTop = sidebar.offsetTop;

    function handleSidebarPosition() {
        if (window.innerWidth >= 1024) { // Apply only for desktops/laptops
            let scrollTop = window.scrollY;
            let footerTop = footer.getBoundingClientRect().top + window.scrollY;
            let sidebarHeight = sidebar.offsetHeight;
            let navbarHeight = navbar ? navbar.offsetHeight : 0; // Ensure navbar exists

            console.log("Scroll:", scrollTop, "Footer:", footerTop, "Sidebar Height:", sidebarHeight, "Navbar Height:", navbarHeight);

            if (scrollTop > sidebarInitialTop - navbarHeight && (scrollTop + sidebarHeight) < footerTop) {
                sidebar.style.position = "fixed";
                sidebar.style.top = navbarHeight + "px"; // Keeps sidebar below navbar
                sidebar.style.bottom = "auto"; // Prevents issues
            } else if ((scrollTop + sidebarHeight) >= footerTop) {
                sidebar.style.position = "absolute";
                sidebar.style.top = (footerTop - sidebarHeight) + "px"; // Stops at footer
            } else {
                sidebar.style.position = "relative";
                sidebar.style.top = "auto";
            }
        } else {
            sidebar.style.position = ""; // Reset for mobile
        }
    }

    window.addEventListener("scroll", handleSidebarPosition);
    window.addEventListener("resize", handleSidebarPosition);
});
*/
